import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  defaultRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: '250px',
    margin: '50px 0',
    alignItems: 'flex-start',
  },
  rowFlexStart: {
    margin: '300px 0',
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: '350px',
    alignItems: 'flex-start',
  },
  boxText: {
    padding: '15px',
    border: '1px solid black',
    borderRadius: '16px',
    backgroundColor: 'white',
    minWidth: '150px',
    textAlign: 'center',
    margin: '10px',
    position: 'relative',
    zIndex: 10,
  },
  connectionPoint: {
    position: 'absolute',
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    border: '2px solid white',
    boxShadow: '0 0 0 1px rgba(0,0,0,0.2), 0 2px 4px rgba(0,0,0,0.1)',
    zIndex: 15,
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'scale(1.2)',
      boxShadow: '0 0 0 2px rgba(0,0,0,0.3), 0 4px 8px rgba(0,0,0,0.2)',
    },
  },
  connectionPointTop: {
    top: '-8px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#1976d2',
  },
  connectionPointBottom: {
    bottom: '-8px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#388e3c',
  },
  connectionPointLeft: {
    left: '-8px',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: '#f57c00',
  },
  connectionPointRight: {
    right: '-8px',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: '#c2185b',
  },
  box: {
    height: '500px',
    margin: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  root: {
    height: '600px',
    maxHeight: '80vh',
    margin: '10px 0px',
    padding: '20px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    '& svg': {
      overflow: 'visible !important',
      zIndex: 1,
    },
    '& .react-archer-arrow': {
      zIndex: 1,
    },
  },
  flowchartContent: {
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    padding: '10px',
    overflow: 'visible',
  },
  fullscreenContent: {
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    padding: '20px',
    overflow: 'visible',
  },
  elementBoxPoint: {
    position: 'relative',
    width: '20px',
    height: '20px',
    display: 'inline-block',
  },
  elementPoint: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: 'black',
    flexShrink: 0,
  },
  elementPointLabel: {
    position: 'absolute',
    bottom: 'calc(100% + 6px)',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    zIndex: 12,
    textAlign: 'center',
  },
  dialogAction: {
    padding: '8px 16px',
    justifyContent: 'space-between',
  },
  dialogContent: {
    padding: 0,
    overflow: 'hidden',
  },
  dialogChildren: {
    height: 'calc(100vh - 64px)',
    overflow: 'auto',
  },
  dataObject: {
    position: 'relative',
    padding: '20px 12px',
    border: '2px solid black',
    borderRadius: 0,
    backgroundColor: 'white',
    minWidth: 100,
    minHeight: 150,
    width: 100,
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    margin: '10px',
    zIndex: 10,
    overflow: 'hidden',
  },
  dataObjectFold: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 0,
    height: 0,
    borderLeft: '16px solid transparent',
    borderBottom: '16px solid #fff',
    zIndex: 11,
  },
  dataObjectFoldEdge: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 16,
    height: 16,
    borderLeft: '2px solid black',
    borderBottom: '2px solid black',
    background: 'transparent',
    zIndex: 12,
    pointerEvents: 'none',
  },
}))

export default styles
